import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 病院管理者一覧
 *
 * 自分が所属しているプライマリ病院の管理者一覧を返す
 */
export class FetchDownload implements APIRequest<Monitaro.FetchDownloadResponse> {
  response: Monitaro.FetchDownloadResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/downloads`
  }
}

/**
 * CSVファイルの生成
 *
 * 指定されたカテゴリのCSVファイルを生成する
 */
export class PostDownload implements APIRequest<Monitaro.PutDownloadResponse> {
  response: Monitaro.PutDownloadResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.DownloadRequest
  constructor(params: Monitaro.DownloadRequest) {
    this.params = params
    this.path = `/downloads`
  }
}
